import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useTeam } from '../store';

import { getRoundParticipantsQuery } from '@queries/competition';
import { hydrateWithTranslations } from '@services/TranslatorService';
/**
 * Check if the current teamId is still in the round of a given competition and set it to the store context if found.
 * @param teamInterestId - The ID of the team interest to check.
 * @param roundId - The ID of the round to check.
 * @returns An object containing the team, undfined.
 */
export const useTeamInterestCheck = (teamInterestId?: string, roundId?: string) => {
  const { data: teams } = useQuery({
    ...getRoundParticipantsQuery({ roundIds: roundId, teamId: teamInterestId }),
    select: (rp) => rp.find(() => true)?.teams.map((t) => hydrateWithTranslations(t)),
    enabled: !!teamInterestId && !!roundId,
  });

  const { setTeam, team } = useTeam();
  useEffect(() => {
    setTeam(teams?.[0]);
  }, [teams, setTeam]);

  return { team };
};
